import { IAppProviderState } from '../interfaces/IAppProviderState';
import { FLOW } from '../interfaces/IPayload';

export const defaultState = {
    occupation: null,
    cpr: {
        valid: false,
        value: '',
    },
    permanentInjuries: [
        { value: '500000', text: '500.000 kr.' },
        { value: '1000000', text: '1.000.000 kr.' },
        { value: '1500000', text: '1.500.000 kr.' },
    ],
    permanentInjury: { value: '1000000', text: '1.000.000 kr.' },
    deathCompensations: [
        { value: '100000', text: '100.000 kr.', alias: '' },
        { value: '300000', text: '300.000 kr.', alias: '' },
        { value: '500000', text: '500.000 kr.', alias: '' },
    ],
    deathCompensation: null,
    modifiedPackageDetails: [],
    modifiedCoverageDetails: [],
    selectedModifiedPackage: null,
    selectedDeductable: null,
    additionalCoverages: {
        DANGEROUS_SPORTS: {
            selected: false,
            data: undefined,
            alias: 'DANGEROUS_SPORTS',
            text: 'Farlig sport',
            value: '',
        },
        DEATH_COMPENSATION: {
            selected: false,
            data: undefined,
            alias: 'DEATH_COMPENSATION',
            text: 'Dødsfald',
            value: '',
        },
    },
    selectedAdditionalCoverages: [],
    selectedPackageIndex: -1,
    isPackageSubmitted: false,
    isPackagePriceLoading: false,
    phoneNo: '',
    personalInformation: {
        customerId: null,
        name: null,
        address: null,
        kvhx: null,
        phone: null,
        email: null,
        useCpr: null,
    },
    termination: {
        yesno: '',
        effectDate: '',
        terminationDate: '',
        company: { text: '', value: '' },
    },
    payment: {
        regno: {
            value: '',
            status: 'invalid',
        },
        account: {
            value: '',
            status: 'invalid',
        },
    },
    paymentPeriod: 'monthly',
    paymentConsents: {
        correctInfo: {
            checked: false,
            status: 'invalid',
        },
        termsConditions: {
            checked: false,
            status: 'invalid',
        },
        isSubmitted: false,
    },
    bannerHeader: '',
    bannerText: '',
    overlayText: '',
    showBannerOverlay: false,
    rmoReason: '',
    name: '',
    quoteId: null,
    hasError: false,
    errorCode: 0,
    isSubmitting: false,
    packages: null,
    packagesDetails: null,
    actualStep: 1,
    previousStep: 1,
    basketAccepted: false,
    ecommerceProduct: undefined,
    hasEboksSubscription: false,
    loadingObjectCache: false,
};

export const initialState: IAppProviderState = {
    statusInitial: true,
    stateChange: false,
    labels: null,
    contentBlocks: {},
    coverageItems: [],
    occupations: [],
    isLoadingComplete: false,
    onPopState: false,
    prevLocation: null,
    giftCard: null,
    sports: '',
    object: null,
    objects: null,
    flow: FLOW.NOT_SET,
    ...defaultState,
};
